module.exports = __webpack_public_path__ + "img/login.797bb368.svg";